import React from 'react';
import PropTypes from 'prop-types';
import FamilyTree from './familyTree/FamilyTree';
import FamilyTreeSummary from './familyTree/FamilyTreeSummary';
import WeatherbysFamilyTree from './familyTree/WeatherbysFamilyTree';
import FlatJumpsTables from './relativesTable/FlatJumpsTables';
import Weatherbys from '../../shared/Weatherbys';

const Pedigree = ({ data: {
    pedigree,
    profile: { weatherbysUid },
    relatives,
    weatherbysPedigreeUrl,
} }) => (
    <section>
        <FamilyTreeSummary {...pedigree} />
        <p>{pedigree.rpFormText}</p>
        { weatherbysPedigreeUrl
            ? <WeatherbysFamilyTree url={weatherbysPedigreeUrl} />
            : <FamilyTree pedigree={pedigree} />
        }
        <FlatJumpsTables
            data={relatives || {}}
            disclaimerName="Relatives"
            flatTitle="Relatives - Flat (GB & IRE)"
            jumpsTitle="Relatives - jumps (GB & IRE)"
            flatNoData="No relatives that ran on the Flat in our records"
            jumpsNoData="No relatives that ran over jumps in our records"
        />
        <Weatherbys
            className="hp-weatherbys__pedigree"
            title="Extended Pedigree"
            type="extended-pedigree"
            weatherbysUid={weatherbysUid}
        />
    </section>
);

Pedigree.propTypes = {
    data: PropTypes.shape({
        profile: PropTypes.shape({
            weatherbysUid: PropTypes.string,
        }),
        weatherbysPedigreeUrl: PropTypes.string,
        relatives: PropTypes.shape({
            FLAT: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
            JUMPS: PropTypes.arrayOf(PropTypes.shape({ horseUid: PropTypes.number })),
        }),
        pedigree: PropTypes.shape({
            horseName: PropTypes.string,
            horseUid: PropTypes.number,
        }).isRequired,
    }).isRequired,
};

export default Pedigree;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/Pedigree.jsx